import { render, staticRenderFns } from "./agreements.vue?vue&type=template&id=088e221c"
import script from "./agreements.ts?vue&type=script&lang=js&external"
export * from "./agreements.ts?vue&type=script&lang=js&external"
import style0 from "./agreements.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports